import { render, staticRenderFns } from "./ProjectTypeTab.vue?vue&type=template&id=2fa949c3"
import script from "./ProjectTypeTab.vue?vue&type=script&lang=js"
export * from "./ProjectTypeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports